import { UserServiceServiceException as __BaseException } from "./UserServiceServiceException";
export class ValidationException extends __BaseException {
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts
        });
        this.name = "ValidationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.fieldList = opts.fieldList;
    }
}
export class NoSuchResource extends __BaseException {
    constructor(opts) {
        super({
            name: "NoSuchResource",
            $fault: "client",
            ...opts
        });
        this.name = "NoSuchResource";
        this.$fault = "client";
        Object.setPrototypeOf(this, NoSuchResource.prototype);
        this.resourceType = opts.resourceType;
        this.resourceId = opts.resourceId;
    }
}
export const License = {
    REGION: "region",
    WORLDWIDE: "worldwide",
};
export const Region = {
    AFRICA: "africa",
    ASIA: "asia",
    EURASIA: "eurasia",
    EUROPE: "europe",
    MIDDLE_EAST: "middle_east",
    NORTH_AMERICA: "north_america",
    OCEANIA: "oceania",
    SOUTH_CENTRAL_AMERICA: "south_central_america",
};
